/* eslint-disable */
export default { codebasever: '0.3.11' }
